<form lin-layout-form (ngSubmit)="onSubmit()" [formGroup]="form">
  <lin-form-label>{{ 'FIELDS.NAME' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="name" autocomplete="off" />
    <mat-error>
      <lin-form-field-error></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-label>{{ 'FIELDS.EMAIL' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="email" autocomplete="off" />
    <mat-error>
      <lin-form-field-error></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-label>{{ 'BILLING.STRIPE.BANK_ACCOUNT' | translate }}</lin-form-label>
  <div id="au-bank-account-element"></div>

  <!-- Used to display bank (branch) name associated with the entered BSB -->
  <div id="bank-name"></div>

  <div class="mandate-acceptance">
    By providing your bank account details, you agree to this Direct Debit Request and the
    <a href="https://stripe.com/au-becs-dd-service-agreement/legal" target="_blank">Direct Debit Request service agreement</a>, and
    authorise Stripe Payments Australia Pty Ltd ACN 160 180 343 Direct Debit User ID number 507156 (“Stripe”) to debit your account through
    the Bulk Electronic Clearing System (BECS) on behalf of Ready Track Pty Ltd trading as Linxio (the "Merchant") for any amounts
    separately communicated to you by the Merchant. You certify that you are either an account holder or an authorised signatory on the
    account listed above.
  </div>

  <lin-form-submit-button type="submit" [isDisabled]="isDisabled" [isLoading]="paymentMethodCreating"
    >{{ 'BILLING.STRIPE.SETUP_BECS' | translate }}</lin-form-submit-button
  >
</form>
